<script setup>
import {defineProps, toRefs} from "vue";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
			value: ''
    })
  },
});
const {data} = toRefs(props);

function get_uploaded_image_asset(path) {
  return ImageService.getCompetitionImagePath(path);
}

</script>

<template>
	<div>
    <ImageRender
        :src="get_uploaded_image_asset('competition/' + data.value)"
        class-name="catalog_image"
        :id="'catalog_image_preview'"
    ></ImageRender>
	</div>
</template>

<style lang="scss" scoped>

</style>